import { Routes } from '@angular/router';

import { authGuard } from '@/auth/guards';
import { AppLayout } from '@/layout/app.layout';
import { AppSimpleLayout } from '@/layout/app.simple.layout';
import {
    ActionLogListingComponent,
    CompetitorListingComponent,
    CompetitorViewComponent,
    DistrictListingComponent,
    DistrictViewComponent,
    StatisticsListingComponent,
    DocumentListingComponent,
    Error,
    NotFound,
    RateListingComponent,
    RateUnitMappingListingComponent,
    ServiceMappingListingComponent,
    UserListingComponent,
    WebVisibilityRulesComponent
} from '@/pages';

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivateChild: [authGuard],
        children: [
            {
                path: '',
                component: UserListingComponent,
                data: { permissions: ['auth.users.read'] }
            },
            {
                path: 'action-logs',
                component: ActionLogListingComponent,
                data: { permissions: ['logs.action_logs.read'] }
            },
            {
                path: 'rates',
                component: RateListingComponent,
                data: { permissions: ['rates.rates.read'] }
            },
            {
                path: 'service-mappings',
                component: ServiceMappingListingComponent,
                data: { permissions: ['service_mappings.service_mappings.read'] }
            },
            {
                path: 'rate-unit-mappings',
                component: RateUnitMappingListingComponent,
                data: { permissions: ['rate_unit_mappings.rate_unit_mappings.read'] }
            },
            {
                path: 'documents',
                component: DocumentListingComponent,
                data: { permissions: ['documents.documents.read'] }
            },
            {
                path: 'statistics',
                component: StatisticsListingComponent,
                data: { permissions: ['districts.district_processing_statistics.read'] }
            },
            {
                path: 'districts',
                data: { permissions: ['districts.district_mappings.read'] },
                children: [
                    {
                        path: '',
                        component: DistrictListingComponent
                    },
                    {
                        path: ':district_mapping_id',
                        component: DistrictViewComponent,
                        data: { permissions: ['districts.district_mappings.view'] },
                    }
                ]
            },
            {
                path: 'competitor-mappings',
                data: { permissions: ['competitor_mappings.competitor_mappings.read'] },
                children: [
                    {
                        path: '',
                        component: CompetitorListingComponent
                    },
                    {
                        path: ':competitor_id',
                        component: CompetitorViewComponent,
                        data: { permissions: ['competitor_mappings.competitor_mappings.view'] },
                    }
                ]
            },
            {
                path: 'app-settings',
                component: WebVisibilityRulesComponent,
                data: { permissions: ['settings.web_visibility_rules.read'] }
            },
        ]
    },
    { path: '', loadChildren: () => import('./app/auth/auth.routes') },
    {
        path: '',
        component: AppSimpleLayout,
        children: [
            { path: 'error', component: Error },
            { path: '**', component: NotFound }
        ]
    }
];
